export const SET_IS_MOBILE = 'SET_IS_MOBILE';
export const TOGGLE_MOBILE_MENU = 'TOGGLE_MOBILE_MENU';


// WEBPACK FOOTER //
// ./src/store/modules/mobile/mutations.js